<template>
  <!-- 用户列表 -->
  <div style="padding: 20px;">
    
    <el-button
      v-if="$store.state.role.role.includes('role.create')"
      type="primary"
      size="mini"
      @click="$refs.roleAdd.show()"
      >添加角色</el-button
    >
    <el-table
      :data="roleList"
      :header-cell-style="{ 'text-align': 'center' }"
      :cell-style="{ padding: '0px' }"
      border
      stripe
    >
      <el-table-column
        v-for="(obj, key, index) in roleKeys"
        :key="index"
        align="center"
        :prop="key"
        :label="obj.value"
      />
      <el-table-column label="操作" align="center">
        <template slot-scope="scope">
          
          <el-button
            v-if="$store.state.role.role.includes('role.edit')"
            type="text"
            size="mini"
            @click="goEdit(scope.row)"
            >权限</el-button
          >
          <!-- $refs.roleEdit.show(scope.row) -->
          <!-- v-if="this.$store.state.role.role.includes('role.edit')" -->
          <el-button
            v-if="$store.state.role.role.includes('role.edit')"
            type="text"
            size="mini"
            @click="$refs.edit.show(scope.row)"
            >编辑</el-button
          >
          <el-button
            type="text"
            size="mini"
            @click="$refs.roleDetail.show(scope.row.id)"
            >查看</el-button
          >
          <!-- v-if="this.$store.state.role.role.includes('role.delete')" -->
          <el-button
            v-if="$store.state.role.role.includes('role.delete')"
            type="text"
            size="mini"
            @click="delList(scope.row)"
            >删除</el-button
          >
        </template>
      </el-table-column>
    </el-table>
    <el-pagination
      style="text-align: center"
      background
      layout="prev, pager, next"
      @current-change="getRoleList"
      :page-size="pageInfo.size"
      :current-page="pageInfo.page"
      :page-count="totalPages"
    >
    </el-pagination>
    <!-- 用户添加弹框 -->
    <role-add-dialog ref="roleAdd" @update="getRoleList(pageInfo.page)" />
    <!-- 用户修改弹框 -->
    <role-edit-dialog ref="roleEdit" @update="getRoleList(pageInfo.page)" />

    <role-detail-dialog ref="roleDetail" @update="getRoleList(pageInfo.page)" />
    <role-edit ref="edit" @update="getRoleList(pageInfo.page)" />
  </div>
</template>

<script>
import * as api from "@/api/factory/user/list";
import {
  roleAddDialog,
  roleEditDialog,
  roleDetailDialog,
  roleEdit,
} from "./components";
export default {
  components: {
    roleAddDialog,
    roleEditDialog,
    roleDetailDialog,
    roleEdit,
  },
  data() {
    return {
      pageInfo: {
        page: 1,
        size: 18,
      },
      totalPages: 0,
      roleList: [],
      roleKeys: {
        id: { value: "角色ID" },
        roleName: { value: "角色名称" },
        factoryId: { value: "工厂ID" },
        isSystems: { value: "是否是系统角色" },
        updateTime: { value: "创建时间" },
      },
    };
  },
  methods: {
    // 获取用户分页列表
    getRoleList(val) {
      this.pageInfo.page = val;
      api.roleList(this.pageInfo).then((res) => {
        this.roleList = this.formatUserList(res.data.list);
        this.totalPages = res.data.pages;
        console.log(this.roleList);
      });
    },
    // 格式化用户列表
    formatUserList(res) {
      res.forEach((user) => {
        user.updateTime = this.utils.timestampToTime(user.updateTime);
        if (user.isSystem == true) {
          user.isSystems = "是";
        } else if (user.isSystem == false) {
          user.isSystems = "否";
        }
      });
      return res;
    },
    delList(row) {
      console.log(row);
      api.delRole({ id: row.id }).then((res) => {
        console.log(res);
        if (res.code == 200) {
          this.getRoleList(1);
          this.$Message.success("删除角色成功!");
        }
      });
    },
    goEdit(row) {
      // location.reload();
      this.$refs.roleEdit.show(row);
    },
  },
  created() {
    console.log(this.$store.state.role.role);
    this.getRoleList(1);
  },
  watch: {
    $route() {
      this.getRoleList(1);
    },
  },
};
</script>

<style lang="scss" scoped>
.el-tag {
  font-size: 15px;
}
</style>
